const logs = [
  { level: "INFO",  message: "User john.smith@acme.com logged in",                                   time: "2026-03-06 09:30:15", ip: "192.168.1.101" },
  { level: "INFO",  message: "Invoice INV-2026-0421 downloaded by john.smith@acme.com",               time: "2026-03-06 11:45:22", ip: "192.168.1.101" },
  { level: "INFO",  message: "User sarah.j@globaltech.com logged in",                                time: "2026-03-06 08:15:44", ip: "10.0.0.45" },
  { level: "WARN",  message: "Failed login attempt for unknown@example.com (3 attempts)",             time: "2026-03-06 07:52:10", ip: "203.45.67.89" },
  { level: "INFO",  message: "New credential request submitted by info@innovationpartners.com",       time: "2026-03-05 16:30:55", ip: "172.16.0.22" },
  { level: "INFO",  message: "Request REQ-2026-0042 status updated to In Progress",                   time: "2026-03-05 15:45:12", ip: "192.168.1.200" },
  { level: "ERROR", message: "Invoice generation failed for SSR-2026-00499 — retry scheduled",       time: "2026-03-05 14:22:08", ip: "internal" },
  { level: "INFO",  message: "Bulk download of 12 invoices by m.brown@enterprise.com",               time: "2026-03-05 13:10:33", ip: "10.0.1.15" },
  { level: "INFO",  message: "Admin admin@vietnamairlines.com approved credentials for Acme Corp",   time: "2026-03-05 11:05:20", ip: "192.168.1.200" },
  { level: "WARN",  message: "Database connection pool at 85% capacity",                              time: "2026-03-05 10:30:00", ip: "internal" },
];

const levelColor = {
  INFO:  "text-green-400",
  WARN:  "text-yellow-400",
  ERROR: "text-red-400",
};

export default function SystemLogsPage() {
  return (
    <div className="p-8">
      <div className="mb-8">
        <h1 className="text-3xl font-semibold text-gray-900">System Logs</h1>
        <p className="text-gray-500 mt-1">Application-level event log</p>
      </div>

      <div className="bg-gray-900 rounded-lg p-4 font-mono text-xs space-y-2 max-h-[600px] overflow-y-auto">
        {logs.map((l, i) => (
          <div key={i} className="flex gap-3 py-0.5">
            <span className="text-gray-500 whitespace-nowrap">{l.time}</span>
            <span className={`font-bold whitespace-nowrap ${levelColor[l.level] || "text-gray-400"}`}>[{l.level}]</span>
            <span className="text-gray-300">{l.message}</span>
            <span className="text-gray-600 ml-auto whitespace-nowrap">{l.ip}</span>
          </div>
        ))}
      </div>

      <div className="mt-4 flex gap-4 text-xs">
        {[["INFO","text-green-600"],["WARN","text-yellow-600"],["ERROR","text-red-600"]].map(([level,color]) => (
          <div key={level} className="flex items-center gap-1.5">
            <div className={`w-2 h-2 rounded-full ${level === "INFO" ? "bg-green-500" : level === "WARN" ? "bg-yellow-500" : "bg-red-500"}`} />
            <span className={`font-medium ${color}`}>{level}</span>
            <span className="text-gray-500">— {logs.filter(l => l.level === level).length} events</span>
          </div>
        ))}
      </div>
    </div>
  );
}
